import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/client";
// import { store } from "../../store";

type FilterState = {
  checkBoxFilters: {
    title: string;
    filters: { name: string; value: string; selected: boolean }[];
  }[];
  price: { minValue: number; maxValue: number };
  filterLoading: boolean;
  paginationOption: {
    page: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  };
  searchKey: string | undefined;
};

const initialState: FilterState = {
  checkBoxFilters: [
    {
      title: "Category",
      filters: [],
    },
    {
      title: "Brand",
      filters: [],
    },
    {
      title: "Warranty Type",
      filters: [],
    },
    {
      title: "Shipping",
      filters: [
        { name: "Free Shipping", value: "Free Shipping", selected: false },
      ],
    },
    {
      title: "Customer Ratings",
      filters: [
        { name: "five-star", value: "⭐⭐⭐⭐⭐", selected: false },
        { name: "four-star", value: "⭐⭐⭐⭐", selected: false },
        { name: "three-star", value: "⭐⭐⭐", selected: false },
        { name: "two-star", value: "⭐⭐", selected: false },
        { name: "one-star", value: "⭐", selected: false },
      ],
    },
    {
      title: "Availability",
      filters: [
        { name: "In Stock", value: "In Stock", selected: false },
        { name: "Pre-order", value: "Pre-order", selected: false },
        { name: "Limited Stock", value: "Limited Stock", selected: false },
      ],
    },

    {
      title: "Storage Capacity",
      filters: [],
    },
    {
      title: "Operating System",
      filters: [],
    },
  ],
  price: { minValue: 0, maxValue: 1000 },
  filterLoading: false,
  paginationOption: { page: 1, pageSize: 10, totalPages: 1, totalRecords: 0 },
  searchKey: undefined,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setInitialState: (state, action) => {
      state.checkBoxFilters = action.payload;
    },
    UPDATE: (state, action) => {

      const updatedFilters = state.checkBoxFilters.map((item: any) => {
        if (item.title === action.payload.title) {
          // console.log(item);
          return {
            ...item,
            filters: item.filters.map((filter: any) => {
              if (filter.value === action.payload.value) {
                return { ...filter, selected: !filter.selected };
              }
              return filter;
            }),
          };
        }
        return item;
      });
      state.checkBoxFilters = updatedFilters;
    },
    PRICE: (state, action) => {
      // console.log(action.payload)
      if (state.price.maxValue !== action.payload.maxValue) {
        state.price.maxValue = action.payload.maxValue;
      }
      if (state.price.minValue !== action.payload.minValue) {
        state.price.minValue = action.payload.minValue;
      }
      //   state.price = action.payload;
    },
    setLoading: (state, action) => {
      state.filterLoading = action.payload;
    },
    setPaginationOption: (state, action) => {
      state.paginationOption.page = action.payload.page;
      state.paginationOption.pageSize = action.payload.pageSize;
      state.paginationOption.totalPages = action.payload.totalPages;
      state.paginationOption.totalRecords = action.payload.totalRecords;
    },
    CLEAR: (state) => {
      // console.log("🚀 ~ state:", state);
      state.price = { minValue: 0, maxValue: 1000 };
      state.checkBoxFilters = state.checkBoxFilters.map((item: any) => ({
        ...item,
        filters: item.filters.map((filter: any) => ({
          ...filter,
          selected: false,
        })),
      }));
      state.paginationOption = {
        page: 1,
        pageSize: 10,
        totalPages: 1,
        totalRecords: 0,
      };
    },
    setSearchKey: (state, action) => {
      state.searchKey = action.payload;
    },
  },
});

export const {
  UPDATE,
  PRICE,
  setInitialState,
  setLoading,
  setPaginationOption,
  CLEAR,
  setSearchKey,
} = filterSlice.actions;
export default filterSlice.reducer;

export function updateFilters(category_id?: number) {
  // const { dispatch } = store;
  return async (dispatch: any, getState: () => any) => {
    try {
      dispatch(setLoading(true));
      const categories = await axiosInstance.get("/categories/parent/list");
      const brands = await axiosInstance.get("/brands");
      const units = await axiosInstance.get("/units");
      const warranty = await axiosInstance.get("/warranties");
      const filterFormatValues = [
        {
          title: "Category",
          filters: categories.data.map((item: any) => ({
            name: item.name,
            value: item.id,
            selected: category_id === item.id,
          })),
        },
        {
          title: "Brand",
          filters: brands.data.map((item: any) => ({
            name: item.brandName,
            value: item.id,
            selected: false,
          })),
        },
        {
          title: "Warranty Type",
          filters: warranty.data.map((item: any) => ({
            name: item.warrantyName,
            value: item.id,
            selected: false,
          })),
        },
        {
          title: "Shipping",
          filters: [
            { name: "Free Shipping", value: "Free Shipping", selected: false },
          ],
        },
        {
          title: "Units",
          filters: units.data.map((item: any) => ({
            name: item.unitName,
            value: item.id,
            selected: false,
          })),
        },
        {
          title: "Availability",
          filters: [
            { name: "In Stock", value: true, selected: false },
            { name: "Out of Stock", value: false, selected: false },
          ],
        },
        {
          title: "Customer Ratings",
          filters: [
            { name: "five-star", value: 5, selected: false },
            { name: "four-star", value: 4, selected: false },
            { name: "three-star", value: 3, selected: false },
            { name: "two-star", value: 2, selected: false },
            { name: "one-star", value: 1, selected: false },
          ],
        },
        
      ];

      await dispatch(setInitialState(filterFormatValues));
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
    }
  };
}
